<template>
  <modal @close="$emit('close')" back="back">
    <template v-slot:header>Set Location</template>

    <div @keyup.esc="$emit('close')" v-focus tabindex="0" class="outline-none">
      <div class="center">
        <div :class="{ busy }" data-placeholder="Type to search for a location" class="border-bottom p2 placed relative">
          <input v-model="form.search" @focus="focussed = true" @blur="focussed = false" @input="search" type="search" class="input border-none center">
        </div>
        <ul class="list-reset mb4 pb2">
          <li v-for="loc in results" :key="loc.place_id" class="py1 h6 mb0">
            <a @click="addNew(loc)" class="inline-block pointer p1">{{ loc.display_name }}</a>
          </li>
          <li v-if="searching" class="py1 h6 mb0">
            <span class="inline-block p1 gray">Searching...</span>
          </li>
          <li class="py1 h6 mb0">
            <a @click="useCurrent" class="inline-block pointer p1">Use Current Location</a>
          </li>
        </ul>
      </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios'
  import debounce from 'debounce'

  export default {
    name: 'LocationPicker',
    data () {
      return {
        searching: false,
        focussed: false,
        form: {
          search: null
        },
        results: null
      }
    },
    computed: {
      location () {
        return this.$store.state.location
      },
      busy () {
        return this.form.search || this.focussed
      }
    },
    methods: {
      search: debounce(function () {
        this.searching = true
        axios.get(process.env.VUE_APP_API_DOMAIN + 'wp-json/ac/v1/geocode', {
          params: { q: this.form.search }
        }).then(({ data }) => {
          // console.log('got data', data)
          this.results = data
          this.searching = false
        })
      }, 400),
      addNew (geo) {
        this.$emit('pick', geo)
        this.$emit('close')
      },
      useCurrent () {
        this.$emit('pick')
        this.$emit('close')
      }
    }
  }
</script>
